import { render, staticRenderFns } from "./LinkDownWidget.vue?vue&type=template&id=0bb030db&"
import script from "./LinkDownWidget.vue?vue&type=script&lang=js&"
export * from "./LinkDownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports